
// import libs
// import cookieBar from './libs/cookieBar';
// import { CountUp } from './libs/CountUp.js';

var $header = $('#header');
var headerHeight = $header.outerHeight();

// import components
// import './components/ie-edge-detection.js';
import './components/menu.js';
// import './components/map.js';
// import './components/filter.js';

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
// function throttle (callback, limit) {
//   var wait = false;
//   return function () {
//     if (!wait) {
//       callback.apply(null, arguments);
//       wait = true;
//       setTimeout(function () {
//         wait = false;
//       }, limit);
//     }
//   }
// }

// https://ehsangazar.com/optimizing-javascript-event-listeners-for-performance-e28406ad406c
// function debounce(func, wait, immediate) {
// 	var timeout;
// 	return function() {
// 		var context = this, args = arguments;
// 		var later = function() {
// 			timeout = null;
// 			if (!immediate) func.apply(context, args);
// 		};
// 		var callNow = immediate && !timeout;
// 		clearTimeout(timeout);
// 		timeout = setTimeout(later, wait);
// 		if (callNow) func.apply(context, args);
// 	};
// };

// init

// AOS animations
// AOS.init({
//   once: true,
//   disable: 'mobile'
// });  

// Parallax
// $(window).ready(function() {
//   $('.parallax').paroller();
//   // console.log($('.parallax'));
//   // $(".paroller").paroller({ factor: '-1', type: 'foreground', direction: 'horizontal' });
// });

// ----------------------------------------
//  scroll to
function scrollTo(e) {

  var href = $.attr(this, 'href');
  if (typeof href === 'undefined') {
      href = $.attr(this, 'data-href');
  }
  href = href.replace('/', '');
  var offset = $.attr(this, 'data-offset');

  var $target = $(href);
  headerHeight = 0;
  if ($target.length) {
      e.preventDefault();
      
      // zavri menu
      $('.nav__toggle').removeClass('is-active');
      $('body').removeClass('menu-active');

      $('html,body').animate({
        scrollTop: $target.offset().top - headerHeight + ((typeof offset !== 'undefined') ? parseInt(offset) : 10)
      }, {
        duration: 500,
        easing: 'swing'
      });
  }
}
$('.scrollTo, .menu-item-type-custom a').on('click', scrollTo);

// ----------------------------------------

// scripts here

// bounce rate event
// var stayOnPage = 10000;
// setTimeout(function(e) {
//   var label = 'na webu alespoň ' + (stayOnPage / 1000) + 's';
//   gtag('event', 'bounce rate fix', {'event_category': 'navstevnik','event_label': label});
// }, stayOnPage);

$('.footer').on('click', '.collapseCustom', function(e) {
  e.preventDefault();
  $(this).toggleClass('show');
});

$('.shops__btn').on('click', function(e) {
  $('.shops').find('.d-none').removeClass('d-none');
  $(this).addClass('d-none');
});

$('.boxes__btn').on('click', function(e) {
  $('.boxes').find('.d-none').removeClass('d-none');
  $(this).addClass('d-none');
});